// Bird card game data with rankings
export const BIRD_CARDS = [
  { id: 1, name: "Blue Jay", rank: 1, image: "/images/bird/bird_1.jpg" },
  { id: 2, name: "Mourning Dove", rank: 2, image: "/images/bird/bird_2.jpg" },
  { id: 3, name: "Song Sparrow", rank: 3, image: "/images/bird/bird_3.jpg" },
  { id: 4, name: "House Finch", rank: 4, image: "/images/bird/bird_4.jpg" },
  { id: 5, name: "Turkey Vulture", rank: 5, image: "/images/bird/bird_5.jpg" },
  { id: 6, name: "Barred Owl", rank: 6, image: "/images/bird/bird_6.jpg" },
  { id: 7, name: "Peregrine Falcon", rank: 7, image: "/images/bird/bird_7.jpg" },
  { id: 8, name: "Cooper's Hawk", rank: 8, image: "/images/bird/bird_8.jpg" },
  { id: 9, name: "House Sparrow", rank: 9, image: "/images/bird/bird_9.jpg" },
  { id: 10, name: "Tufted Titmouse", rank: 10, image: "/images/bird/bird_10.jpg" },
  { id: 11, name: "Cedar Waxwing", rank: 11, image: "/images/bird/bird_11.jpg" },
  { id: 12, name: "Merlin", rank: 12, image: "/images/bird/bird_12.jpg" },
  { id: 13, name: "Yellow Warbler", rank: 13, image: "/images/bird/bird_13.jpg" },
  { id: 14, name: "Mallard", rank: 14, image: "/images/bird/bird_14.jpg" },
  { id: 15, name: "House Wren", rank: 15, image: "/images/bird/bird_15.jpg" },
  { id: 16, name: "American Robin", rank: 16, image: "/images/bird/bird_16.jpg" },
  { id: 17, name: "Chipping Sparrow", rank: 17, image: "/images/bird/bird_17.jpg" },
  { id: 18, name: "Northern Cardinal", rank: 18, image: "/images/bird/bird_18.jpg" },
  { id: 19, name: "Northern Mockingbird", rank: 19, image: "/images/bird/bird_19.jpg" },
  { id: 20, name: "Great Horned Owl", rank: 20, image: "/images/bird/bird_20.jpg" },
  { id: 21, name: "American Crow", rank: 21, image: "/images/bird/bird_21.jpg" },
  { id: 22, name: "Bushtit", rank: 22, image: "/images/bird/bird_22.jpg" },
  { id: 23, name: "Rock Pigeon", rank: 23, image: "/images/bird/bird_23.jpg" },
  { id: 24, name: "American Goldfinch", rank: 24, image: "/images/bird/bird_24.jpg" },
  { id: 25, name: "Common Raven", rank: 25, image: "/images/bird/bird_25.jpg" },
  { id: 26, name: "European Starling", rank: 26, image: "/images/bird/bird_26.jpg" },
  { id: 27, name: "Brown Creeper", rank: 27, image: "/images/bird/bird_27.jpg" },
  { id: 28, name: "Steller's Jay", rank: 28, image: "/images/bird/bird_28.jpg" },
  { id: 29, name: "Brown-headed Cowbird", rank: 29, image: "/images/bird/bird_29.jpg" },
  { id: 30, name: "Common Nighthawk", rank: 30, image: "/images/bird/bird_30.jpg" }
];
